import { render, staticRenderFns } from "./rescue-agreement.vue?vue&type=template&id=8ee260fa"
import script from "./rescue-agreement.vue?vue&type=script&lang=js"
export * from "./rescue-agreement.vue?vue&type=script&lang=js"
import style0 from "./rescue-agreement.vue?vue&type=style&index=0&id=8ee260fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports